import React, { useEffect, useState } from 'react'
import { CircularProgressbar, CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import { CategoryResponse } from './LeadContact';
import { Progress } from 'reactstrap';
import { OverallPercentage } from '../../models/LeadModels';
import Service from '../../services';
import { useParams } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import { catchError } from '../../utils/Utils';
import { GetResponseCategoreis } from '../../models/ClientportalDashboardModels/GetResponseCategoreis';
import { IActionBtnsModel, WIDGET_TYPE } from '../../models/StatusTabModel';

interface reviewprogressProps {
  actionBtns:IActionBtnsModel[]
  onActionSignBtnClick: any;
  onActionBtnClick:any;
}

function ComplianceReviewPercentage(props:reviewprogressProps) {
    const [loader, setLoader] = useState<boolean>(false);
    const [percentageData,setPercentageData] = useState<OverallPercentage>()     
    const [categories,setCategories] = useState<[CategoryResponse]>()
    const { clientId, clientProductsId, trackerName } = useParams();
    const service = new Service(); 
   

  const getCompliancePercentage = () =>{
    setLoader(true);
    service.getComplianceOverallPercentage(clientProductsId).then(
          (response:AxiosResponse<OverallPercentage>)=>{ 
                     
             setPercentageData(response?.data)              
            
        }).catch((error:any)=>{
          catchError(error,true);
          setLoader(false);
        });
      }
    
    const getClientportalMainPageCategories = () => {
        setLoader(true);
        service.getComplianceCategoriesByClientId(clientProductsId).then(
              (response: AxiosResponse<{categories:[CategoryResponse]}>) => {
                               
                 setCategories(response?.data?.categories || [])
              }).catch((error:any)=>{
                catchError(error,true);
                setLoader(false);
              });
      
      }
      const getCategoriesByClientId = () => {
        setLoader(true);
        service.getCategoriesByClientId(clientProductsId).then(
              (response: AxiosResponse<CategoryResponse>) => {
                              
                 //setCategories(response?.data)
              }).catch((error:any)=>{
                catchError(error,true);
                setLoader(false);
              });
      
      }
  
    useEffect(()=> {
        getCompliancePercentage() 
         getClientportalMainPageCategories()     
    },[])
  return (
    <>
         <div className="progress-container">
                <div className="account-progress-container">
                  <div className="title-applicationprogress">
                   Underwriting Review Progress 
                  </div>
                  <div className="circular">
                    <div className="circular-progressbar"></div>
                    <CircularProgressbarWithChildren 
                value={
                  percentageData?.overallPercentage === undefined||percentageData?.overallPercentage===null
                    ? 0
                    : percentageData?.overallPercentage
                }
                styles={buildStyles({
                  // Text size
                  textSize: "24px",
                  // How long animation takes to go from one percentage to another, in seconds
                  pathTransitionDuration: 2.0,
                  // Colors
                  pathColor: `rgba(0,0,0,0.2, ${
                    percentageData?.overallPercentage===undefined||percentageData?.overallPercentage===null
                      ? 0 / 100
                      : percentageData?.overallPercentage / 100
                  })`,
                  textColor: "#0C2240",
                  trailColor: "rgb(235 235 235)",
                  backgroundColor: "#0C2240",
                })}
              >
                <div className="circularbartext">{`${
                  percentageData?.overallPercentage === undefined||percentageData?.overallPercentage===null
                    ? 0
                    : percentageData?.overallPercentage
                }%`}</div>
                <div className="complete">COMPLETE</div>
                </CircularProgressbarWithChildren > 
                  </div>
                 
                  <div>
                  {categories&&categories.length&& props.actionBtns && props.actionBtns?.length > 0 ? (
                              props.actionBtns?.filter(each => each.widgetType === WIDGET_TYPE.ACTION_BUTTON && each.label
                                ==="Review Application").map((each) => (
                                <button
                                  key={each?.label}
                                  className="review-actiontitle"
                                  onClick={() =>{props.onActionBtnClick(each)}}
                                >
                                  {each?.label}
                                </button>
                              ))
                            ) : (
                              <></>
                            )}</div>
                  {categories&&categories.length&&categories?.map((c: CategoryResponse, index: number) => {
                    return (
                      <div className="progress-bar" key={index}>
                        <div className="categoryProgressBar">
                          <div className="categoryDiv">
                            <span className="categoryName">{c.displayName}</span>
                            <span className="categoryPercentage">
                              {c.parentCategoeryCompletedPercentage}%
                            </span>
                          </div>
                          <Progress
                            clssName="categoryProgress"
                            value={c.parentCategoeryCompletedPercentage}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
    </>
  )
}

export default ComplianceReviewPercentage
